module.exports = __webpack_public_path__ + "static/media/ic_whats_not_covered_myway.509c228b.svg";